import type { FeedbackResult } from '@trello/ai-labs/feedback-collector';
import { Analytics } from '@trello/atlassian-analytics';

import { getAiBoardBuilderFeedbackAttributes } from './getAiBoardBuilderFeedbackAttributes';

/**
 * Fires the standard `aiFeedback submitted` event for the board-level AI Board
 * Builder thumbs, alongside the ai-labs collector's own `button clicked`.
 * `singleInstrumentationID` is the board creation span id the collector was
 * shown with; without it the feedback can't be joined to its `aiResult viewed`,
 * so nothing is sent.
 */
export const trackAiBoardBuilderFeedbackSubmitted = (
  boardId: string,
  aiFeedbackResult: FeedbackResult,
  singleInstrumentationID?: string,
): void => {
  if (!singleInstrumentationID) {
    return;
  }

  Analytics.sendTrackEvent({
    action: 'submitted',
    actionSubject: 'aiFeedback',
    source: 'boardScreen',
    containers: { board: { id: boardId } },
    attributes: {
      aiFeatureName: 'aiBoardBuilder',
      isAIFeature: 1,
      userGeneratedAI: 1,
      proactiveGeneratedAI: 0,
      singleInstrumentationID,
      aiFeedbackResult,
      ...getAiBoardBuilderFeedbackAttributes(boardId),
    },
  });
};
